import { Outlet } from 'react-router-dom';
import { SseProcessingTimeoutProvider } from 'contexts/SseProcessingTimeoutProvider';

const SseProcessingTimeoutLayout = () => (
  <SseProcessingTimeoutProvider>
    <Outlet />
  </SseProcessingTimeoutProvider>
);

export default SseProcessingTimeoutLayout;
